import ApplicationRouter from './ApplicationRouter';

export default {
    ApplicationRouter
};